
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93cJC59C_45HqRDgYITV2BTr6Y5U75z1D_m4XfEIm_45fXOsQMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/[...slug].vue?macro=true";
import { default as indexf3rn9fGH1FlxvHiDoQfqXJz1q3_8d_45J_q7ZcGYLqqm4Meta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/index.vue?macro=true";
import { default as indexp5vcxSbIrLlLh_45m0yLYK7qoGhsJDL4UTnRZoxBanLfMMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/index.vue?macro=true";
import { default as indexvTsECePjt_45GGUtGRJvndzuGoOEWruUUCLufKl_FMzDIMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/index.vue?macro=true";
import { default as indexd8ke2ggfX59fme71YaAA4otdbdL_45vqyU6H_vZsISouAMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/caches/index.vue?macro=true";
import { default as createABQiJT4T_45wK5dxACfu_BUh9xHpod9veWVrUYgVI8t3AMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/create.vue?macro=true";
import { default as createBE8iwu1ywyRptr2QIzStK4hLn__45rcodmIW1gbDEXvNYMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/create.vue?macro=true";
import { default as create26llmb8BljI7yj4e0BZG_L74PbJB7UDzRoFgShfVJXoMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/create.vue?macro=true";
import { default as indexqS07zBiKkT57pK9HU3TPlOF5EE9aXSNvo029JiX4UlMMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/index.vue?macro=true";
import { default as createOeAEVEX_45TKLTKnJFSMihdel5dvTPu6n9AabxXjf5wG0Meta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/create.vue?macro=true";
import { default as indexfm_45hjmCdX1DpA4YB061Doap8TgiBlZcubnH98CLFqf0Meta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/index.vue?macro=true";
import { default as _91id_93ompwrH7xa7u0BEmScNzV9w18gqB1ZPALVwx5Xi0ErDQMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/edit/[id].vue?macro=true";
import { default as _91id_93UMjoHH6jt9S7So00uf1026zI_45yaH9hQsMDgMvabwU_45cMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/edit/[id].vue?macro=true";
import { default as createmXg_qgjf6MeLP8MPxFIHv8QCT__45mCQ7G208Lu48ySS4Meta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/create.vue?macro=true";
import { default as _91id_93TpQKLNS0rUbSQ_45mFPmodFPPp_SIZTHSXlGZ_45BsYNaW8Meta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/edit/[id].vue?macro=true";
import { default as indexxj0XP_45CCxdm1FYMg_456xfsOmzgaiqdVvWnL2ifkTuOlEMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/index.vue?macro=true";
import { default as _91id_934ekXLmurWcYIbFYW0mBRI_YO4KxPJZlAJXTT4ael8y4Meta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/edit/[id].vue?macro=true";
import { default as indexzXcm4c_45hx_45Gi6wOvj6M5U45u6Akr60LocwtPV1DQjmEMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/style-guide/index.vue?macro=true";
import { default as create3I5THRKJbolj3uapYzX9eIY7h4CTaOKEOXHTYFXlWzcMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/create.vue?macro=true";
import { default as _91id_935CfaJwgpHtOD1iEWKdW9Ix3lCDu8_j7m10imDBC5JPsMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/copy/[id].vue?macro=true";
import { default as _91id_93Gxn4tJwDHfim57efuMHExBqMhONaE3yrWdIQg_2DKFYMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/edit/[id].vue?macro=true";
import { default as _91id_93ooyoAfRGvkeIdQDQYjQfaNAek9PZl_kvmBgCTvIeQWwMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/edit/[id].vue?macro=true";
import { default as indexLGsD1RyrENvHdPvoRpovR8d8yj9VzQiI7BT4UOFldfIMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/index.vue?macro=true";
import { default as createGTSJjYHI2TjAsQ1LHxEPu3hXkUr35xTX_45bEGOkfoMWQMeta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/create.vue?macro=true";
import { default as _91id_93nhNMOrRp_45_XDSIjDo1Z3_f7zyfsZwqtfKPZDINn7010Meta } from "/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/edit/[id].vue?macro=true";
import { default as voix_45debugDEeKypkOOLJIDQKx4rhUHOFbH7trb_WD1own0Vh8SnIMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix-debug.vue?macro=true";
import { default as PreviewCEoF87Bv8lGAfYnqE5EkdxcFsLkNp8yYfUtDuWozjyoMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Preview.vue?macro=true";
import { default as IndexzUdPMMaILH5Xe__45FZkOmKVp74RQ8v941td0PkbfROSUMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/settings-menu/Index.vue?macro=true";
import { default as loginhuiWflBq1JYK2uU3TWwUKpasxOibyhd5l0M9givqsFQMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/login.vue?macro=true";
import { default as callbackZJ7a7hUwi7oE6BKlBzEEYzGA4XUO3KUNq0e167L6b4QMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/callback.vue?macro=true";
import { default as studioiGaaRINseIsQbgKBScWC2hs_rIyODLJb7UpUzlE0wLUMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/studio.vue?macro=true";
import { default as IndexJ7_ZlwGG1s4dxfDj9DLDSzaskTa5oax3qFITjWmYFVIMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Index.vue?macro=true";
import { default as EditTrc2pGb8b9rTzzkYxHFErbCOCoEnTv7fpu_WuLxIeDMMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Edit.vue?macro=true";
import { default as Create76_45Df_888ayDviHKr7qZPIKIdJYYjkBz6Br02YXMoB8Meta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Create.vue?macro=true";
import { default as IndextnwH_45Y7gENqykIwqckIkqxouXh7Cjk0Rmgv0BiZHee0Meta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Index.vue?macro=true";
import { default as Create1_45gpIwH8wXrj6kny0cZZmxa4C0ISV_U1aQG7rBIK2f4Meta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Create.vue?macro=true";
import { default as TranslateGmsrOsv9CeIp_45bCHeao1tGIH4rA_45g2dMLX0Asq_B0z8Meta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Translate.vue?macro=true";
import { default as Copy5bWzuCi7uBms9r_wmTZyz7Kjf07vuB1qpuFRfkTlpicMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Copy.vue?macro=true";
import { default as IndexQD9_63dmimM62Y_45UDwY7SLH2K4jIp4lAz2JaOFE9e2kMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Index.vue?macro=true";
import { default as IndexQAjxnK2X7IcFiaKzFVm9gwJFhI97gAO_coO5K_w_rXoMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Index.vue?macro=true";
import { default as Editx59oJtob2vCFsiFvwAb0TN0tNBFdp6jrmqSm1hRCuAgMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Edit.vue?macro=true";
import { default as CreateVvdYhuoleWYM5QiuR7NfybP4VBw7AkSTYkppK9IWxXcMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Create.vue?macro=true";
import { default as IndexIdH0DEckdLY5DTP2ekNCHxUaiG8LAdCdGyCeBZ9IR5QMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Index.vue?macro=true";
import { default as CreateeIvVa3oO4wlem62CFdi6_45O7EQt_45YLb2CepKP9mIY_hIMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Create.vue?macro=true";
import { default as EditzP4pqX1i4nXaMob5Sgg40Y73pG6gtNcQg3tbFJ1vfDgMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Edit.vue?macro=true";
import { default as Profilekg_45fHSXgiO0Qxt_45rYR6_45kMO5MCl4gVVHpV9wJu2jLGYMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Profile.vue?macro=true";
import { default as indexMqOOq7YhZsn51_45Dlyc_45u75F1aZOu8BylZFpqKy47t9UMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/index.vue?macro=true";
import { default as SlicesViewH2wBUwoxilF5eq1JEzG1a7kY32D8VA7sMBvYNrfi8xcMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicesView.vue?macro=true";
import { default as TemplateViewIW7xQlO6r_45NA_FxqGxkfhSkWAVwc8VB1gQilPy_ipmQMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/TemplateView.vue?macro=true";
import { default as DesignGuideViewH1Y2s47zjI_45qkm48OIgesuSv3U1UG7IJEwkpvxuuyK4Meta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/DesignGuideView.vue?macro=true";
import { default as slicerJyJrtsxvLxOzHx2d1qNQJ3WlVTxWbxuw6WqzUduSoSIMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/slicer.vue?macro=true";
import { default as documentiHcnm1cnW4HV_45rqeeV9Trp51_85kny9z6HbiKtI0qiUMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/documentation/document.vue?macro=true";
import { default as voixPjEtt9NoO5y7gHUNtyoYuq_EEX339s_45NYEga9G0_45mDwMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix.vue?macro=true";
import { default as SlicePreviewWolLxmwZGI4bWmaJrbBH1s1nY9fzLqXqWevqbPIIKCUMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicePreview.vue?macro=true";
import { default as previewp9a6bn2nG58EzJpD4HpHhs57k3j2NMqqe_45hesVW5e2oMeta } from "/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/preview.vue?macro=true";
export default [
  {
    name: "slug-en",
    path: "/:slug(.*)*",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/[...slug].vue")
  },
  {
    name: "slug-es",
    path: "/es/:slug(.*)*",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/[...slug].vue")
  },
  {
    name: "voix-menus-en",
    path: "/voix/menus",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/index.vue")
  },
  {
    name: "voix-menus-es",
    path: "/es/voix/menus",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/index.vue")
  },
  {
    name: "voix-posts-en",
    path: "/voix/posts",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/index.vue")
  },
  {
    name: "voix-posts-es",
    path: "/es/voix/posts",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/index.vue")
  },
  {
    name: "voix-brands-en",
    path: "/voix/brands",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/index.vue")
  },
  {
    name: "voix-brands-es",
    path: "/es/voix/brands",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/index.vue")
  },
  {
    name: "voix-caches-en",
    path: "/voix/caches",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/caches/index.vue")
  },
  {
    name: "voix-caches-es",
    path: "/es/voix/caches",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/caches/index.vue")
  },
  {
    name: "voix-menus-create-en",
    path: "/voix/menus/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/create.vue")
  },
  {
    name: "voix-menus-create-es",
    path: "/es/voix/menus/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/create.vue")
  },
  {
    name: "voix-posts-create-en",
    path: "/voix/posts/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/create.vue")
  },
  {
    name: "voix-posts-create-es",
    path: "/es/voix/posts/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/create.vue")
  },
  {
    name: "voix-brands-create-en",
    path: "/voix/brands/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/create.vue")
  },
  {
    name: "voix-brands-create-es",
    path: "/es/voix/brands/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/create.vue")
  },
  {
    name: "voix-resorts-en",
    path: "/voix/resorts",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/index.vue")
  },
  {
    name: "voix-resorts-es",
    path: "/es/voix/resorts",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/index.vue")
  },
  {
    name: "voix-resorts-create-en",
    path: "/voix/resorts/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/create.vue")
  },
  {
    name: "voix-resorts-create-es",
    path: "/es/voix/resorts/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/create.vue")
  },
  {
    name: "voix-specials-en",
    path: "/voix/specials",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/index.vue")
  },
  {
    name: "voix-specials-es",
    path: "/es/voix/specials",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/index.vue")
  },
  {
    name: "voix-menus-edit-id-en",
    path: "/voix/menus/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/edit/[id].vue")
  },
  {
    name: "voix-menus-edit-id-es",
    path: "/es/voix/menus/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/menus/edit/[id].vue")
  },
  {
    name: "voix-posts-edit-id-en",
    path: "/voix/posts/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/edit/[id].vue")
  },
  {
    name: "voix-posts-edit-id-es",
    path: "/es/voix/posts/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/posts/edit/[id].vue")
  },
  {
    name: "voix-specials-create-en",
    path: "/voix/specials/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/create.vue")
  },
  {
    name: "voix-specials-create-es",
    path: "/es/voix/specials/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/create.vue")
  },
  {
    name: "voix-brands-edit-id-en",
    path: "/voix/brands/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/edit/[id].vue")
  },
  {
    name: "voix-brands-edit-id-es",
    path: "/es/voix/brands/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/brands/edit/[id].vue")
  },
  {
    name: "voix-fact-sheets-en",
    path: "/voix/fact-sheets",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/index.vue")
  },
  {
    name: "voix-fact-sheets-es",
    path: "/es/voix/fact-sheets",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/index.vue")
  },
  {
    name: "voix-resorts-edit-id-en",
    path: "/voix/resorts/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/edit/[id].vue")
  },
  {
    name: "voix-resorts-edit-id-es",
    path: "/es/voix/resorts/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/resorts/edit/[id].vue")
  },
  {
    name: "voix-style-guide-en",
    path: "/voix/style-guide",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/style-guide/index.vue")
  },
  {
    name: "voix-style-guide-es",
    path: "/es/voix/style-guide",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/style-guide/index.vue")
  },
  {
    name: "voix-fact-sheets-create-en",
    path: "/voix/fact-sheets/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/create.vue")
  },
  {
    name: "voix-fact-sheets-create-es",
    path: "/es/voix/fact-sheets/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/create.vue")
  },
  {
    name: "voix-specials-copy-id-en",
    path: "/voix/specials/copy/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/copy/[id].vue")
  },
  {
    name: "voix-specials-copy-id-es",
    path: "/es/voix/specials/copy/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/copy/[id].vue")
  },
  {
    name: "voix-specials-edit-id-en",
    path: "/voix/specials/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/edit/[id].vue")
  },
  {
    name: "voix-specials-edit-id-es",
    path: "/es/voix/specials/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/specials/edit/[id].vue")
  },
  {
    name: "voix-fact-sheets-edit-id-en",
    path: "/voix/fact-sheets/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/edit/[id].vue")
  },
  {
    name: "voix-fact-sheets-edit-id-es",
    path: "/es/voix/fact-sheets/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/fact-sheets/edit/[id].vue")
  },
  {
    name: "voix-booking-code-triggers-en",
    path: "/voix/booking-code-triggers",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/index.vue")
  },
  {
    name: "voix-booking-code-triggers-es",
    path: "/es/voix/booking-code-triggers",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/index.vue")
  },
  {
    name: "voix-booking-code-triggers-create-en",
    path: "/voix/booking-code-triggers/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/create.vue")
  },
  {
    name: "voix-booking-code-triggers-create-es",
    path: "/es/voix/booking-code-triggers/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/create.vue")
  },
  {
    name: "voix-booking-code-triggers-edit-id-en",
    path: "/voix/booking-code-triggers/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/edit/[id].vue")
  },
  {
    name: "voix-booking-code-triggers-edit-id-es",
    path: "/es/voix/booking-code-triggers/edit/:id()",
    component: () => import("/Users/cdm/code/turbo/playaresorts/apps/voix/pages/voix/booking-code-triggers/edit/[id].vue")
  },
  {
    name: "voix-debug",
    path: "/voix-debug",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix-debug.vue")
  },
  {
    name: "voix-preview-release-entry-en",
    path: "/preview-release/:releaseId/:previewSecret",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Preview.vue")
  },
  {
    name: "voix",
    path: "/voix",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix.vue"),
    children: [
  {
    name: "voix-settings-en",
    path: "",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/settings-menu/Index.vue")
  },
  {
    name: "voix-login-en",
    path: "login",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/login.vue")
  },
  {
    name: "voix-auth-callback-en",
    path: "auth/callback",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/callback.vue")
  },
  {
    name: "voix-studio-en",
    path: "studio",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/studio.vue")
  },
  {
    name: "voix-settings-head-tags-en",
    path: "head-tags",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Index.vue")
  },
  {
    name: "voix-settings-head-tags-edit-en",
    path: "head-tags/:id",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Edit.vue")
  },
  {
    name: "voix-settings-head-tags-create-en",
    path: "head-tags/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Create.vue")
  },
  {
    name: "voix-settings-pages-en",
    path: "pages",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Index.vue")
  },
  {
    name: "voix-settings-pages-create-en",
    path: "pages/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Create.vue")
  },
  {
    name: "voix-settings-pages-translate-en",
    path: "pages/translate",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Translate.vue")
  },
  {
    name: "voix-settings-pages-copy-en",
    path: "pages/copy",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Copy.vue")
  },
  {
    name: "voix-settings-releases-en",
    path: "releases",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Index.vue")
  },
  {
    name: "voix-settings-redirects-en",
    path: "redirects",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Index.vue")
  },
  {
    name: "voix-settings-redirects-edit-en",
    path: "redirects/:id",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Edit.vue")
  },
  {
    name: "voix-settings-redirects-create-en",
    path: "redirects/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Create.vue")
  },
  {
    name: "voix-settings-users-en",
    path: "users",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Index.vue")
  },
  {
    name: "voix-settings-users-create-en",
    path: "users/create",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Create.vue")
  },
  {
    name: "voix-settings-users-edit-en",
    path: "users/:id",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Edit.vue")
  },
  {
    name: "voix-settings-users-profile-en",
    path: "profile",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Profile.vue")
  },
  {
    name: "voix-cookbook-en",
    path: "cookbook",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/index.vue")
  },
  {
    name: "voix-slicer-en",
    path: "slicer",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/slicer.vue"),
    children: [
  {
    name: "voix-slicer-slices-en",
    path: "",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicesView.vue")
  },
  {
    name: "voix-slicer-template-en",
    path: "templates/:templateName",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/TemplateView.vue")
  },
  {
    name: "voix-slicer-design-guide-en",
    path: "design-guide",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/DesignGuideView.vue")
  }
]
  },
  {
    name: "voix-documentation-en",
    path: "documentation/:documentPath(.*)?",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/documentation/document.vue")
  }
]
  },
  {
    name: "slicer-slice-en",
    path: "/voix/slice-preview/:sliceName",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicePreview.vue")
  },
  {
    name: "cookbook-preview-en",
    path: "/voix/cookbook-preview/:recipe(.*)",
    component: () => import("/Users/cdm/code/turbo/playaresorts/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/preview.vue")
  }
]